import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css'
})
export class NavbarComponent {

  private router = inject(Router);
  private auth   = inject(AuthService);

  theme        = inject(ThemeService);   // shared singleton, not `new ThemeService()`
  isLoggedIn$  = this.auth.isLoggedIn$;
  user$        = this.auth.user$;

  showProfileMenu = false;
  isStudentPanel  = false;
  showCourses     = false;
  showStudents    = false;
  showSubjects    = false;
  showLanguage    = false;
  navOpen         = false;

  constructor() {
    this.isStudentPanel = this.router.url.startsWith('/student');
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: any) => {
      this.isStudentPanel = e.url.startsWith('/student');
      this.navOpen = false;
    });
  }
  get logoPath(): string {
  return this.theme.isDark()
    ? 'assets/images/ToT-Dark-Logo.png'
    : 'assets/images/ToT-Light-Logo.png';
  }
  toggleNav() {
    this.navOpen = !this.navOpen;
  }

  toggleProfileMenu() {
    this.showProfileMenu = !this.showProfileMenu;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.profile-menu')) {
      this.showProfileMenu = false;
    }
    if (!target.closest('.topbar')) {
      this.navOpen = false;
    }
  }

  goToProfile() {
    const role = this.auth.getCurrentRole();
    switch (role) {
      case 'student': this.router.navigate(['/student/account']); break;
      case 'teacher': this.router.navigate(['/TeacherPanel/MyProfile']); break;
      case 'parent':  this.router.navigate(['/ParentPanel/MyProfile']); break;
      default:        this.router.navigate(['/']); break;
    }
    this.showProfileMenu = false;
  }

  // goToSettings() {
  //   const role = this.auth.getCurrentRole();
  //   switch (role) {
  //     case 'student': this.router.navigate(['/student/manageaccount']); break;
  //     case 'teacher': this.router.navigate(['/TeacherPanel/MyProfile']); break;
  //     case 'parent':  this.router.navigate(['/ParentPanel/MyProfile']); break;
  //     default:        this.router.navigate(['/']); break;
  //   }
  //   this.showProfileMenu = false;
  // }

  logout() {
    this.auth.logout();
    this.showProfileMenu = false;
    this.router.navigate(['/']);
  }
}
